import React from 'react';
import classNames from 'classnames/bind';
import { cssUtils } from "../internal/CssUtils";
import { Circle, Flow } from './components';
import styles from './Loader.css';
var cx = classNames.bind(styles);
var mapLoader = {
  circle: Circle,
  flow: Flow
};

var Loader = function Loader(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'normal' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'N60' : _ref$color,
      _ref$view = _ref.view,
      view = _ref$view === void 0 ? 'circle' : _ref$view;
  var CurrentLoader = mapLoader[view];
  return /*#__PURE__*/React.createElement("div", {
    className: cx('root', cssUtils("color_".concat(color)))
  }, /*#__PURE__*/React.createElement(CurrentLoader, {
    size: size
  }));
};

export default Loader;